import { render, staticRenderFns } from "./PathSVG.vue?vue&type=template&id=6fda352d&scoped=true&"
import script from "./PathSVG.vue?vue&type=script&lang=js&"
export * from "./PathSVG.vue?vue&type=script&lang=js&"
import style0 from "./PathSVG.vue?vue&type=style&index=0&id=6fda352d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda352d",
  null
  
)

export default component.exports